import { useTranslation } from '@blocs.i18n';

const MIN_TALENT_AGE_IN_YEARS = 2;

type AgeType = {
  years: string;
  months: string;
};

export const useTalentAge = () => {
  const { t } = useTranslation();

  return (age: AgeType): string => {
    if (!age.years) return '';

    if (Number(age.years) >= MIN_TALENT_AGE_IN_YEARS) return age.years;

    if (Number(age.years) < MIN_TALENT_AGE_IN_YEARS)
      return `${Number(age.years) * 12 + Number(age.months)} ${t('common:suffix.months')}`;

    return '';
  };
};
